import {useState} from 'react';
import {Search} from './components/search';
import {SearchSvg} from '@/icons';
import Icon from '@/components/Icon';
import Tooltip, {TooltipTrigger} from '@/components/Tooltip';
import {getDocType, getUUID} from './components/utils';
import {startSidebarSearch} from '@/buried/common';
import './sidebarSearch.scss';

export function SidebarSearch(props: any) {
    const {canCreateDoc} = props;
    const [showSearch, setShowSearch] = useState(false);

    function handleClickIcon() {
        setShowSearch(true);
        const docType = getDocType();
        // 激活搜索埋点
        startSidebarSearch({
            name: 'active_search',
            'query_id': getUUID(),
            'doc_type': docType,
        });
    }

    function handleOnBlur() {
        setShowSearch(false);
    }

    return (<div
        className="sidebar-search"
        {
            ...props
        }
    >
        <Search
            onBlur={handleOnBlur}
            visible={showSearch}
            canCreateDoc={canCreateDoc}
            placeholder={'搜索标题'}
        />
        {
            showSearch
                ? null
                :
                <Tooltip
                    trigger={TooltipTrigger.Hover}
                    content={'搜索标题'}
                    placement="top"
                >
                    <div
                        onClick={handleClickIcon}
                        className="sidebar-search-icon"
                    >
                        <Icon
                            svg={SearchSvg}
                        />
                    </div>
                </Tooltip>
        }
    </div>);
}
